import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconFace = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.95}
      d="M19.883 10.742c.351.86-.235 1.758-1.328 1.758h-1.211v2.54a2.45 2.45 0 0 1-2.461 2.46h-2.461V20H2.46l.039-6.914C.937 11.719 0 9.726 0 7.5 0 3.36 3.32 0 7.46 0h2.93c2.657 0 5.118 1.328 6.641 3.477.938 1.367 2.07 5.43 2.852 7.265ZM13.71 8.75c.703 0 1.21-.547 1.21-1.25 0-.664-.585-1.25-1.21-1.25-.664 0-1.211.586-1.211 1.25 0 .703.508 1.25 1.21 1.25Z"
    />
  </svg>
));
export default SvgIconFace;
